import { IGroupCallChanged, IIncomingCall } from '@gem/call/Model/callModel.types';

import Tasks from 'APP/Tasks';
import { AUTO_DECLINE_REASON } from 'APP/model/mainCall/mainCallModel.types';
import Entities from 'STORE';

export async function handleBatchedActiveCalls(calls: IGroupCallChanged[]): Promise<void> {
  Entities.BackgroundCalls.replace(calls);
  Tasks.calls.checkAndRunAwaitCall();
}

export async function handleChangeActiveCall(call: IGroupCallChanged): Promise<void> {
  Tasks.calls.updateActiveCall(call);
}

export async function handleStartedCall(call: IIncomingCall): Promise<void> {
  console.log('INCOMING_CALL', '2 handleStartedCall', JSON.stringify(call));
  await Promise.all([
    Tasks.relationships.loadUnknownUsersByIds({
      usersIds: [call.callerId],
    }),
    Tasks.relationships.loadUnknownGroupsByIds({
      groupsIds: [call.groupId],
    }),
  ]);

  const isMeInitiator = Entities.usersStore.Me.id === call.callerId;

  if (isMeInitiator) {
    return;
  }
  console.log(
    'INCOMING_CALL',
    '3 handleStartedCall check for decline',
    JSON.stringify({
      hasOngoingCall: !!Entities.Calls.ongoingCall,
      hasStream: Entities.ActiveStream.hasStream,
      hasWaitingRoomRequest: Entities.Calls.hasWaitingRoomRequest,
    })
  );

  if (Entities.Calls.ongoingCall) {
    Tasks.calls.decline({
      groupId: call.groupId,
      channelId: call.channelId,
      reason: AUTO_DECLINE_REASON.call,
    });
    return;
  }

  if (Entities.ActiveStream.hasStream) {
    Tasks.calls.decline({
      groupId: call.groupId,
      channelId: call.channelId,
      reason: AUTO_DECLINE_REASON.stream,
    });
    return;
  }

  if (Entities.Calls.hasWaitingRoomRequest) {
    Tasks.calls.decline({
      groupId: call.groupId,
      channelId: call.channelId,
      reason: AUTO_DECLINE_REASON.waitingRoom,
    });
    return;
  }

  Entities.IncomingCalls.add({
    ...call,
  });
}
